export default __webpack_public_path__ + "static/media/PorscheFavicon.a6dee4b6.ico";